export const AddressCardComponent = {
    bindings: {
        address: '<'
    },
    template: `
        <p class="ca-customer-address-name" c-type="body-md-primary bold">{{$ctrl.address.name}}</p>
        <p class="ca-customer-address-address-1" c-type="title-sm-primary">{{$ctrl.address.address1}}</p>
        <p class="ca-customer-address-address-2" c-type="title-sm-primary" ng-if="$ctrl.address.address2">{{$ctrl.address.address2}}</p>
        <p class="ca-customer-address-city-state-zip" c-type="title-sm-primary">{{$ctrl.address.city}}, {{$ctrl.address.state}} {{$ctrl.address.zipCode}}</p>
        <p class="ca-customer-address-notes" ng-if="$ctrl.address.notes" c-type="title-xs-primary"><br/>{{$ctrl.address.notes}}</p>
    `
};
